import { render, staticRenderFns } from "./home-gjmy.vue?vue&type=template&id=6995f560&scoped=true&"
import script from "./home-gjmy.vue?vue&type=script&lang=ts&"
export * from "./home-gjmy.vue?vue&type=script&lang=ts&"
import style0 from "./home-gjmy.vue?vue&type=style&index=0&id=6995f560&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6995f560",
  null
  
)

export default component.exports